const ADD_TO_BAG = 'addToBag'
const BLUR = 'blur'
const CLICK = 'click'
const DOM_CONTENT_LOADED = 'DOMContentLoaded'
const ERROR = 'error'
const EVENT = 'Event'
const FOCUS = 'focus'
const HASHCHANGE = 'hashchange'
const KEY_DOWN = 'keydown'
const KEY_UP = 'keyup'
const KEYPRESS = 'keypress'
const LAZY_LOADED = 'lazyLoaded'
const LOAD = 'load'
const MOUSE_DOWN = 'mousedown'
const MOUSE_MOVE = 'mousemove'
const REMOVE_FROM_CART = 'removeFromCart'
const RESIZE = 'resize'
const SCROLL = 'scroll'
const MOUSE_ENTER = 'mouseenter'
const MOUSE_LEAVE = 'mouseleave'
const FOCUS_FIRST_INVALID_ELEMENT_ON_DELIVERY_FORM_SUBMIT =
  'focusFirstInvalidElementOnDeliveryFormSubmit'
const UPDATE_VALUES_FROM_GOOGLE = 'updateValuesFromGoogle'
const TOOGLE_HEADER = 'toogleHeader'

export const EVENTS = {
  LOAD,
  ERROR,
  MOUSE_MOVE,
  SCROLL,
  CLICK,
  EVENT,
  LAZY_LOADED,
  KEY_UP,
  RESIZE,
  REMOVE_FROM_CART,
  ADD_TO_BAG,
  DOM_CONTENT_LOADED,
  HASHCHANGE,
  KEYPRESS,
  FOCUS,
  KEY_DOWN,
  BLUR,
  MOUSE_DOWN,
  MOUSE_ENTER,
  MOUSE_LEAVE,
  FOCUS_FIRST_INVALID_ELEMENT_ON_DELIVERY_FORM_SUBMIT,
  UPDATE_VALUES_FROM_GOOGLE,
  TOOGLE_HEADER,
}

export const RB_HEADER_CONTAINER = 'rb-header__container'
export const RB_HEADER_MESSAGE_BAR_CONTAINER = 'message-bar__container'
export const RB_HEADER_NAVIGATION = 'rb-header__navigation'

export const FC_LUX_PRICE = 'fc-lux-price'
export const HEADER_SCROLLED = 'header-scrolled'
// TODO: Remove this constant
export const MOBILE_PANELS_OPEN = 'mobile-panels-open'
export const MOBILE_PANELS = 'rb-pdp-mobile-panels'
export const MODAL_CONTENT_WRAPPER = 'modal-content-wrapper'
export const MODAL_WRAPPER__DISPLAY = 'modal-wrapper--display'
export const MODAL_WRAPPER__FOOTER = 'modal-wrapper--footer'
export const NAVIGATION__ACTION__WISHLIST = 'navigation__action--wishlist'
export const ORDER_RECVD_DATE = 'order-recvd-date'
export const PDP_NAV_MOBILE = 'pdp-nav-mobile'
export const PLP_MENU_CLOSED = 'plp-menu-closed'
export const PLP_PRODUCTS__COLLAPSABLE = 'plp-products__collapsable'
export const PROMO_STRIPES = 'promo-stripes'
export const RB_ANIMATION = 'rb-animation'
export const RB_ANIMATION__IMG = 'rb-animation--img'
export const RB_ANIMATION__IMG_START = 'rb-animation--img-start'
export const RB_ANIMATION__PARALLAX = 'rb-animation--parallax'
export const RB_ANIMATION__TEXT = 'rb-animation--text'
export const RB_ANIMATION__TEXT_START = 'rb-animation--text-start'
export const RB_ANIMATION_HOVER = 'rb-animation-hover'
export const RB_ANIMATION_HOVER__TILT = 'rb-animation-hover--tilt'
export const RB_APP__CONFIRMED_TEXT = 'rb-app__confirmed-text'
export const RB_APP__HEADER = 'rb-app__header'
export const RB_APP__MAIN = 'rb-app__main'
export const RB_BTN = 'rb-btn'
export const RB_BTN__SEARCH = 'rb-btn__search'
export const RB_BTN__TOGGLE = 'rb-btn__toggle'
export const RB_CMS_REGISTRATION_FORM__ERROR = 'rb-cms-registration-form__error'
export const RB_EDITORIAl = 'rb-editorial'
export const RB_EDITORIAL__BACKGROUND = 'rb-editorial__background'
export const RB_EDITORIAL__CONTENT = 'rb-editorial__content'
export const RB_EDITORIAL__CTA = 'rb-editorial--cta'
export const RB_EDITORIAL__LAZY = 'rb-editorial--lazy'
export const RB_EDITORIAL_ARTICLE__CTA = 'rb-editorial-article__cta'
export const RB_EDITORIAL_ARTICLE__EXCERPT = 'rb-editorial-article__excerpt'
export const RB_EDITORIAL_ARTICLE__TITLE = 'rb-editorial-article__title'
export const RB_FIELDROW__HELPER = 'rb-fieldrow__helper'
export const RB_FILTERS__FILTER_CONTAINER = 'rb-filters__filter-container'
export const RB_FOOTER = 'rb-footer'
export const RB_FOOTER__MAIL = 'rb-footer__mail'
export const RB_IMAGE_NEWSLETTER = 'rb-image-newsletter'
export const RB_IS_ACTIVE = 'rb-is-active'
export const RB_LOADED = 'rb-loaded'
export const RB_MENU__LI = 'rb-menu__li'
export const RB_MENU__LI__SELECTED = 'rb-menu__li--selected'
export const RB_MINICART__RECAP_TOTAL = 'rb-minicart__recap-total'
export const RB_MODAL_CLOSE = 'rb-modal-close'
export const RB_NAV__PROMO_CONTENT = 'rb-nav__promo-content'
export const RB_NAV__PROMO_CONTENT_MAIN = 'rb-nav__promo-content-main'
export const RB_NAV__PROMO_CONTENT_SECONDARY = 'rb-nav__promo-content-secondary'
export const RB_PDP_DELIVERY_PANEL = 'rb-pdp-delivery-panel'
export const RB_PDP_LEFT_BREADCRUMB = 'rb-pdp-left-breadcrumb'
export const RB_PDP_LEFT_SWIPER = 'rb-pdp-left-swiper'
export const RB_PDP_MAIN = 'rb-pdp-main'
export const RB_PDP_RIGHT = 'rb-pdp-right'
export const RB_PDP_SIDEPANEL = 'rb-pdp-sidepanel'
export const RB_PDP_STICKY_BAR = 'rb-pdp-sticky-bar'
export const RB_PDP_STICKY_BAR__ADD = 'rb-pdp-sticky-bar--add'
export const RB_PDP_STICKY_BAR_MOBILE__TOTAL_PRICES = 'rb-pdp-sticky-bar-mobile__total-prices'
export const RB_PDP_STICKY_BAR__PRICE = 'rb-pdp-sticky-bar__price'
export const RB_PLP_ACTIONS = 'rb-plp-actions'
export const RB_PLP_CONTAINER = 'rb-plp-container'
export const RB_PLP_PRODUCT_TILE = 'rb-plp-product-tile'
export const RB_PLP_PRODUCT_TILE__CAROUSEL = 'rb-plp-product-tile__carousel'
export const RB_PLP_PRODUCT_TILE__CONTAINER = 'rb-plp-product-tile__container'
export const RB_PLP_PRODUCT_TILE__MINI = 'rb-plp-product-tile__mini'
export const RB_PLP_PRODUCT_TILE__POSTER = 'rb-plp-product-tile__poster'
export const RB_PILL_RED = 'rb-pill--red'
export const RB_PILL_BLACK = 'rb-pill--black'
export const RB_SIDEBAR_CONTENT = 'rb-sidebar-content'
export const RB_SWIPER = 'rb-swiper'
export const STATIC_HEADER = 'static-header'
export const STICKY_BAR_MOBILE_PRICES_FALLBACK = 'rb-pdp-sticky-bar-mobile__prices-fallback'
export const STICKY_BAR_MOBILE_PRICES_WRAPPER = 'rb-pdp-sticky-bar-mobile__prices-wrapper'
export const STORE_LOCATOR_CLOSE_INFOWINDOW_BUTTON = 'info-window__close-button'
export const STORE_LOCATOR_GOOGLE_CLUSTERING_LABEL = 'rb-google-map__clustering-label'
export const STORIES_CLONE_HEIGHT = 'stories-clone-height'
export const SWIPER_CONTROL_PDP_CUSTOM_GESTURE = 'swiper-control-pdp-custom-gesture'
export const SWIPER_SLIDE = 'swiper-slide'
export const SWIPER_SLIDE_ACTIVE = 'swiper-slide-active'
export const SWIPER_WRAPPER = 'swiper-wrapper'
export const UKDC_ERROR = 'ukdc-error'
export const V_FACEBOOK_LOGIN = 'v-facebook-login'
export const WCS_CONTAINER = 'wcs-container'
export const WCS_HIDDEN = 'wcs-hidden'
export const WCS_HIDE = 'wcs-hide'
export const WCS_SHOPPING_GRANDTOTAL_JS = 'wcs-shopping-grandtotal-js'
export const WCS_STAR_CONTAINER = 'wcs-star-container'
export const WCS_STATIC_PAGE = 'wcs-static-page'
export const WISHLIST_CLOSE = 'wishlist-close'
export const STICKY_BAR_MOBILE_NOT_AVAILABLE = 'rb-pdp-sticky-bar-mobile__not-available'
export const CONSENT_PROMPT_SUBMIT_NO = 'consent_prompt_submitNo'
export const YOUTUBE_ICON = 'common__icon--youtube-dark'
export const PREFERENCES_PROMPT_SUBMIT = 'preferences_prompt_submit'
export const TRIGGER = 'trigger'
export const DO_NOT_TRIGGER = 'do not trigger'
export const GO_TO_PREFERENCES_LINK = '#__tealiumGDPRecModal a'
export const BUTTONS_DISABLED = 'buttons-date-disabled'
